export default __webpack_public_path__ + "static/media/jason3.d36fc1c0.jpg";